import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitEnquiry = (payload) =>
  axios.post(`${API}/enquiries`, payload, { timeout: 15000 });

export const adminLogin = (passcode) =>
  axios.post(`${API}/admin/login`, { passcode }, { timeout: 15000 });

export const fetchEnquiries = (token) =>
  axios.get(`${API}/admin/enquiries`, {
    headers: { Authorization: `Bearer ${token}` },
    timeout: 15000,
  });

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x)))
      .filter(Boolean)
      .join(", ");
  return String(detail);
}
